var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE1Update({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8699",
    "data-name": "Rectangle 8699",
    width: 16.656,
    height: 16.658,
    fill: "#0072ce"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-E1_Update"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "E1_Update",
    "data-name": "E1 Update",
    clipPath: "url(#clip-E1_Update)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11798",
    "data-name": "Group 11798",
    transform: "translate(0.672 0.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11797",
    "data-name": "Group 11797",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22262",
    "data-name": "Path 22262",
    d: "M0,7.68a2.948,2.948,0,0,0,.094-.634A8.109,8.109,0,0,1,1.107,4.18,8.33,8.33,0,0,1,4.327,1.025,7.924,7.924,0,0,1,7.18.076,8.232,8.232,0,0,1,12.924,1.4a.153.153,0,0,0,.239-.027C13.545.977,13.937.595,14.32.2a.536.536,0,0,1,.615-.165.523.523,0,0,1,.337.54c0,1.008.006,2.016,0,3.025a.523.523,0,0,1-.571.562c-1.008,0-2.017,0-3.025,0a.522.522,0,0,1-.534-.316.5.5,0,0,1,.145-.614c.294-.3.587-.593.886-.884.1-.1.1-.145-.024-.221a7.258,7.258,0,0,0-2.02-.858A7.109,7.109,0,0,0,7.625,1.08a7.2,7.2,0,0,0-3.7,1.457,7.152,7.152,0,0,0-2.53,3.591,7.046,7.046,0,0,0-.328,2.65A8.117,8.117,0,0,0,1.346,10.4a.536.536,0,0,1-.338.693.532.532,0,0,1-.671-.4,7.562,7.562,0,0,1-.3-1.65A.176.176,0,0,0,0,8.916Z",
    transform: "translate(0 0)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22263",
    "data-name": "Path 22263",
    d: "M21.392,95.268a.672.672,0,0,1-.379-.7c0-.97-.019-1.94-.026-2.91a.515.515,0,0,1,.558-.555h3.041a.513.513,0,0,1,.533.318.522.522,0,0,1-.145.6c-.3.3-.6.613-.9.913-.088.087-.078.124.023.188a7.164,7.164,0,0,0,2.5.971,6.95,6.95,0,0,0,2,.1,7.3,7.3,0,0,0,6.14-4.682,7.432,7.432,0,0,0,.419-1.717,7.217,7.217,0,0,0-.249-2.931.527.527,0,1,1,1.012-.29,8.314,8.314,0,0,1,.307,3.074,8.182,8.182,0,0,1-2.987,5.7,7.979,7.979,0,0,1-3.831,1.787c-.286.05-.574.088-.861.131H27.279c-.025-.04-.065-.031-.1-.033a5.032,5.032,0,0,1-.815-.11,8.149,8.149,0,0,1-3.023-1.249c-.1-.068-.153-.045-.228.032-.358.368-.723.73-1.082,1.1a1.175,1.175,0,0,1-.345.261Z",
    transform: "translate(-19.603 -78.611)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22264",
    "data-name": "Path 22264",
    d: "M63.162,67.282a4.165,4.165,0,1,1,4.106,4.188,4.173,4.173,0,0,1-4.106-4.188M66.8,69.2a.607.607,0,0,0,.492-.2q1.146-1.229,2.287-2.463a.645.645,0,0,0,.138-.651.68.68,0,0,0-1.157-.266q-.839.884-1.657,1.787c-.1.105-.144.1-.234,0-.187-.2-.385-.4-.584-.588a.686.686,0,1,0-.973.968c.4.407.8.807,1.2,1.208a.632.632,0,0,0,.484.2",
    transform: "translate(-58.997 -58.971)",
    fill: "#0072ce"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE1Update);
export default __webpack_public_path__ + "static/media/E1 Update.17bc4a622655a8fc2a09d7e8a67207d8.svg";
export { ForwardRef as ReactComponent };